if (!window.spotlightAjaxFilterInitialized) {
    window.spotlightAjaxFilterInitialized = true;

    const normalizePathname = (pathname) => pathname.replace(/\/+$/, '') || '/';

    const scrollToFilterTarget = (hash) => {
        const targetId = hash ? hash.replace(/^#/, '') : 'CollectionProductGrid';
        const target = document.getElementById(targetId);
        if (!target) return;

        window.scrollTo({
            top: target.getBoundingClientRect().top + window.pageYOffset - 50,
            behavior: 'smooth'
        });
    };

    const canApplyAjaxCollectionFilter = () => {
        return typeof CollectionFiltersForm !== 'undefined'
            && typeof CollectionFiltersForm.renderPage === 'function'
            && document.getElementById('CollectionProductGrid')
            && document.getElementById('main-collection-product-grid');
    };

    const syncFilterFormFromParams = (searchParams) => {
        const params = new URLSearchParams(searchParams);
        const sortBy = params.get('sort_by');
        if (!sortBy) return;

        const sortInput = document.querySelector('#CollectionFiltersForm [name="sort_by"]');
        if (sortInput) sortInput.value = sortBy;
    };

    const handleSpotlightAjaxFilterClick = (event) => {
        const link = event.target.closest('[data-spotlight-ajax-filter]');
        if (!link || !link.href) return;
        if (event.defaultPrevented) return;
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

        let targetUrl;
        try {
            targetUrl = new URL(link.href, window.location.href);
        } catch (error) {
            return;
        }

        if (targetUrl.origin !== window.location.origin) return;
        if (normalizePathname(targetUrl.pathname) !== normalizePathname(window.location.pathname)) return;

        const searchParams = targetUrl.search.startsWith('?') ? targetUrl.search.slice(1) : targetUrl.search;

        if (!searchParams) {
            if (!targetUrl.hash) return;
            const hashTarget = document.getElementById(targetUrl.hash.replace(/^#/, ''));
            if (!hashTarget) return;
            event.preventDefault();
            scrollToFilterTarget(targetUrl.hash);
            return;
        }

        if (!canApplyAjaxCollectionFilter()) return;

        event.preventDefault();
        syncFilterFormFromParams(searchParams);
        CollectionFiltersForm.renderPage(searchParams, null);
        scrollToFilterTarget(targetUrl.hash);
    };

    document.addEventListener('click', handleSpotlightAjaxFilterClick);
}
